import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/home/Home'
import About from './pages/about/About'
import Contact from './pages/contact/Contact'
import Gallery from './pages/gallery/Gallery'
import Pricing from './pages/pricing/Pricing'
import Teachers from './pages/teachers/Teachers'
import Classes from './pages/classes/Class'
import NotFound from './pages/notFound/NotFound'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import MyBookings from './pages/myBookings/MyBookings';
import WaiverPage from "./pages/waiver/WaiverPage";
import MembershipAgreementPage from "./pages/membershipAgreement/MembershipAgreementPage";

function Layout() {
  const location = useLocation();
  const hideChrome = location.pathname === '/waiver' || location.pathname === '/membership-agreement';
  return (
    <>
      {!hideChrome && <Navbar />}
      <Routes>
        <Route index element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/classes" element={<Classes />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/waiver" element={<WaiverPage />} />
        <Route path="/membership-agreement" element={<MembershipAgreementPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideChrome && <Footer />}
    </>
  );
}

const App = () => (
  <BrowserRouter>
    <Layout />
  </BrowserRouter>
);

export default App